<div class="p-3" *ngIf="detail">
  <div class="card mb-3">
    <div class="card-header bg-primary text-white">
      <h5 class="mb-0">تصمیمات مجمع عمومی فوق‌العاده</h5>
    </div>
    <div class="card-body">
      <div class="row g-3">
        <div class="col-md-6"><strong>نماد:</strong> {{detail.symbol}}</div>
        <div class="col-md-6"><strong>ISIN:</strong> {{detail.isin}}</div>
        <div class="col-md-6"><strong>عنوان شرکت:</strong> {{detail.title}}</div>
        <div class="col-md-6"><strong>سال مالی:</strong> {{detail.fiscalYear}}</div>
        <div class="col-md-6"><strong>ماه پایان سال:</strong> {{detail.yearEndMonth}}</div>
        <div class="col-md-6"><strong>تاریخ مجمع:</strong> {{detail.assemblyDate_ParentInfo || '-'}}</div>
        <div class="col-md-6"><strong>ساعت:</strong> {{detail.assemblyHour || '-'}}</div>
        <div class="col-md-6"><strong>روز:</strong> {{detail.assemblyDay || '-'}}</div>
        <div class="col-md-6"><strong>محل برگزاری:</strong> {{detail.assemblyLocation || '-'}}</div>
        <div class="col-md-6"><strong>نتیجه مجمع:</strong> {{detail.assemblyResultTypeTitle || '-'}}</div>
        <div class="col-md-6"><strong>رئیس مجمع:</strong> {{detail.assemblyChief || '-'}}</div>
        <div class="col-md-6"><strong>ناظر اول:</strong> {{detail.assemblySuperVisor1 || '-'}}</div>
        <div class="col-md-6"><strong>ناظر دوم:</strong> {{detail.assemblySuperVisor2 || '-'}}</div>
        <div class="col-md-6"><strong>منشی:</strong> {{detail.assemblySecretary || '-'}}</div>
        <div class="col-md-6"><strong>تاریخ انتشار نامه:</strong> {{detail.letterPublishDate || '-'}}</div>
        <div class="col-md-6"><strong>شماره ردیابی نامه:</strong> {{detail.letterTracingNo || '-'}}</div>
        <div class="col-md-6"><strong>وضعیت تغییر سرمایه:</strong> {{getCapitalChangeStateLabel(detail.capitalChangeState)}}</div>
        <div class="col-md-6"><strong>نسخه:</strong> {{detail.version}}</div>
      </div>
      <div class="mt-3">
        <a class="btn btn-outline-primary btn-sm" [href]="detail.htmlUrl" target="_blank" rel="noopener noreferrer">
          <i class="fa fa-external-link"></i> مشاهده در CODAL
        </a>
        <button class="btn btn-secondary btn-sm ms-2" (click)="goBack()">
          <i class="fa fa-arrow-right"></i> بازگشت
        </button>
      </div>
    </div>
  </div>

  <!-- Current Capital Information -->
  <div class="card mb-3">
    <div class="card-header">اطلاعات سرمایه فعلی</div>
    <div class="card-body">
      <div class="row g-3">
        <div class="col-md-4"><strong>سرمایه فعلی:</strong> <span [title]="getTomanTooltip(detail.lastCapital)">{{formatNumber(detail.lastCapital)}} ریال</span></div>
        <div class="col-md-4"><strong>تعداد سهام:</strong> {{formatNumber(detail.lastShareCount)}}</div>
        <div class="col-md-4"><strong>ارزش اسمی سهم:</strong> <span [title]="getTomanTooltip(detail.lastShareValue)">{{formatNumber(detail.lastShareValue)}} ریال</span></div>
      </div>
    </div>
  </div>

  <!-- Capital Increase Section -->
  <div class="card mb-3" *ngIf="detail.increaseCapitals && detail.increaseCapitals.length > 0">
    <div class="card-header">افزایش سرمایه</div>
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-striped table-sm mb-0">
          <thead>
            <tr>
              <th>نوع افزایش</th>
              <th>مبلغ افزایش (ریال)</th>
              <th>درصد افزایش</th>
              <th>آورده نقدی</th>
              <th>سود انباشته</th>
              <th>اندوخته</th>
              <th>مازاد تجدید ارزیابی</th>
              <th>صرف سهام</th>
              <th>تعداد سهام قابل عرضه</th>
              <th>قیمت سهام</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of detail.increaseCapitals">
              <td>{{getCapitalIncreaseTypeLabel(item.type)}}</td>
              <td class="text-end" [title]="getTomanTooltip(item.capitalIncreaseValue)">{{formatNumber(item.capitalIncreaseValue)}}</td>
              <td class="text-end">{{formatPercent(item.increasePercent)}}</td>
              <td class="text-end" [title]="getTomanTooltip(item.cashIncoming)">{{formatNumber(item.cashIncoming)}}</td>
              <td class="text-end" [title]="getTomanTooltip(item.retainedEarning)">{{formatNumber(item.retainedEarning)}}</td>
              <td class="text-end" [title]="getTomanTooltip(item.reserves)">{{formatNumber(item.reserves)}}</td>
              <td class="text-end" [title]="getTomanTooltip(item.revaluationSurplus)">{{formatNumber(item.revaluationSurplus)}}</td>
              <td class="text-end" [title]="getTomanTooltip(item.sarfSaham)">{{formatNumber(item.sarfSaham)}}</td>
              <td class="text-end">{{formatNumber(item.CashForceclosurePriorityAvailableStockCount)}}</td>
              <td class="text-end" [title]="getTomanTooltip(item.cashForceclosurePriorityStockPrice)">{{formatNumber(item.cashForceclosurePriorityStockPrice)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-body" *ngIf="detail.increaseCapitals[0]?.cashForceclosurePriorityStockDesc">
        <p class="mb-0"><strong>توضیحات:</strong> {{detail.increaseCapitals[0].cashForceclosurePriorityStockDesc}}</p>
      </div>
    </div>
  </div>

  <!-- Capital Decrease Section -->
  <div class="card mb-3" *ngIf="detail.decreaseCapital && detail.decreaseCapital.isAccept">
    <div class="card-header">کاهش سرمایه</div>
    <div class="card-body">
      <div class="row g-3">
        <div class="col-md-3"><strong>مبلغ کاهش:</strong> <span [title]="getTomanTooltip(detail.decreaseCapital.capitalDecreaseValue)">{{formatNumber(detail.decreaseCapital.capitalDecreaseValue)}} ریال</span></div>
        <div class="col-md-3"><strong>درصد کاهش:</strong> {{formatPercent(detail.decreaseCapital.decreasePercent)}}</div>
        <div class="col-md-3"><strong>سرمایه جدید:</strong> <span [title]="getTomanTooltip(detail.decreaseCapital.newCapital)">{{formatNumber(detail.decreaseCapital.newCapital)}} ریال</span></div>
        <div class="col-md-3"><strong>تعداد سهام جدید:</strong> {{formatNumber(detail.decreaseCapital.newShareCount)}}</div>
        <div class="col-md-3"><strong>ارزش اسمی جدید:</strong> <span [title]="getTomanTooltip(detail.decreaseCapital.newShareValue)">{{formatNumber(detail.decreaseCapital.newShareValue)}} ریال</span></div>
      </div>
    </div>
  </div>

  <!-- Company/Fiscal Year Changes Section -->
  <div class="card mb-3" *ngIf="detail.isNameChange || detail.isActivitySubjectChange || detail.isLocationChange || detail.isFinancialYearChange">
    <div class="card-header">تغییرات شرکت و سال مالی</div>
    <div class="card-body">
      <div class="row g-3" *ngIf="detail.isNameChange">
        <div class="col-md-6"><strong>نام قبلی:</strong> {{detail.oldName || '-'}}</div>
        <div class="col-md-6"><strong>نام جدید:</strong> {{detail.newName || '-'}}</div>
      </div>
      <div class="row g-3 mt-2" *ngIf="detail.isActivitySubjectChange">
        <div class="col-md-6"><strong>موضوع فعالیت قبلی:</strong> {{detail.oldActivitySubject || '-'}}</div>
        <div class="col-md-6"><strong>موضوع فعالیت جدید:</strong> {{detail.newActivitySubject || '-'}}</div>
      </div>
      <div class="row g-3 mt-2" *ngIf="detail.isLocationChange">
        <div class="col-md-6"><strong>آدرس قبلی:</strong> {{detail.oldAddress || '-'}}</div>
        <div class="col-md-6"><strong>آدرس جدید:</strong> {{detail.newAddress || '-'}}</div>
      </div>
      <div class="row g-3 mt-2" *ngIf="detail.isFinancialYearChange">
        <div class="col-md-6"><strong>تاریخ پایان سال مالی قبلی:</strong> {{detail.oldFinancialYearEndDate || '-'}}</div>
        <div class="col-md-6"><strong>تاریخ پایان سال مالی جدید:</strong> {{detail.newFinancialYearEndDate || '-'}}</div>
      </div>
    </div>
  </div>

  <!-- Session Orders -->
  <div class="card mb-3">
    <div class="card-header">دستور جلسات</div>
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-striped table-sm mb-0">
          <thead>
            <tr>
              <th style="width: 50px;">ردیف</th>
              <th>توضیحات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of detail.sessionOrders; let i = index">
              <td>{{i + 1}}</td>
              <td>{{item.description}}</td>
            </tr>
            <tr *ngIf="!detail.sessionOrders || detail.sessionOrders.length === 0">
              <td colspan="2" class="text-center text-muted">موردی ثبت نشده است</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Board Members -->
  <div class="card mb-3">
    <div class="card-header">اعضای هیئت‌مدیره</div>
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-striped table-sm mb-0">
          <thead>
            <tr>
              <th>نام</th>
              <th>کد ملی</th>
              <th>نماینده</th>
              <th>سمت</th>
              <th>نوع عضویت</th>
              <th>تحصیلات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let member of detail.assemblyBoardMembers">
              <td>{{member.fullName}}</td>
              <td>{{member.nationalCode}}</td>
              <td>{{member.agentBoardMemberFullName || '-'}}</td>
              <td>{{getBoardPositionLabel(member.position)}}</td>
              <td>{{getBoardMembershipLabel(member.membershipType)}}</td>
              <td>{{member.degree || '-'}} {{member.educationField ? '- ' + member.educationField : ''}}</td>
            </tr>
            <tr *ngIf="!detail.assemblyBoardMembers || detail.assemblyBoardMembers.length === 0">
              <td colspan="6" class="text-center text-muted">موردی ثبت نشده است</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- CEO and Audit Committee -->
  <div class="card mb-3" *ngIf="detail.ceo || detail.auditCommitteeChairman">
    <div class="card-header">مدیران شرکت</div>
    <div class="card-body">
      <div class="row g-3" *ngIf="detail.ceo">
        <div class="col-12"><h6 class="text-primary">مدیرعامل</h6></div>
        <div class="col-md-4"><strong>نام:</strong> {{detail.ceo.fullName}}</div>
        <div class="col-md-4"><strong>کد ملی:</strong> {{detail.ceo.nationalCode}}</div>
        <div class="col-md-4"><strong>تحصیلات:</strong> {{detail.ceo.degree}} - {{detail.ceo.educationField}}</div>
      </div>
      <hr *ngIf="detail.ceo && detail.auditCommitteeChairman" class="my-3">
      <div class="row g-3" *ngIf="detail.auditCommitteeChairman">
        <div class="col-12"><h6 class="text-primary">رئیس کمیته حسابرسی</h6></div>
        <div class="col-md-4"><strong>نام:</strong> {{detail.auditCommitteeChairman.fullName}}</div>
        <div class="col-md-4"><strong>کد ملی:</strong> {{detail.auditCommitteeChairman.nationalCode}}</div>
        <div class="col-md-4"><strong>تحصیلات:</strong> {{detail.auditCommitteeChairman.degree}} - {{detail.auditCommitteeChairman.educationField}}</div>
      </div>
    </div>
  </div>

  <!-- Shareholders -->
  <div class="card mb-3">
    <div class="card-header">سهامداران حاضر در مجمع</div>
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-striped table-sm mb-0">
          <thead>
            <tr>
              <th style="width: 80px;">ردیف</th>
              <th>نام سهامدار</th>
              <th style="width: 150px;">تعداد سهام</th>
              <th style="width: 100px;">درصد</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of detail.shareHolders">
              <td>{{item.shareHolderSerial || '-'}}</td>
              <td>{{item.name || '-'}}</td>
              <td class="text-end">{{formatNumber(item.shareCount)}}</td>
              <td class="text-end">{{formatPercent(item.sharePercent)}}</td>
            </tr>
            <tr *ngIf="!detail.shareHolders || detail.shareHolders.length === 0">
              <td colspan="4" class="text-center text-muted">موردی ثبت نشده است</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Other Descriptions -->
  <div class="card mb-3" *ngIf="detail.otherDes">
    <div class="card-header">سایر موارد</div>
    <div class="card-body">
      <p class="mb-0">{{detail.otherDes}}</p>
    </div>
  </div>

  <!-- Next Session Information -->
  <div class="card mb-3" *ngIf="detail.nextSessionDate || detail.nextSessionBreakDesc">
    <div class="card-header">اطلاعات جلسه بعدی</div>
    <div class="card-body">
      <div class="row g-3">
        <div class="col-md-4" *ngIf="detail.nextSessionDate"><strong>تاریخ جلسه بعدی:</strong> {{detail.nextSessionDate}}</div>
        <div class="col-md-4" *ngIf="detail.nextSessionHour"><strong>ساعت:</strong> {{detail.nextSessionHour}}</div>
        <div class="col-md-4" *ngIf="detail.nextSessionDay"><strong>روز:</strong> {{detail.nextSessionDay}}</div>
        <div class="col-12" *ngIf="detail.nextSessionLocation"><strong>محل برگزاری:</strong> {{detail.nextSessionLocation}}</div>
        <div class="col-12" *ngIf="detail.nextSessionBreakDesc"><strong>توضیحات:</strong> {{detail.nextSessionBreakDesc}}</div>
      </div>
    </div>
  </div>
</div>

<div class="d-flex justify-content-center align-items-center" style="min-height: 400px;" *ngIf="!detail">
  <div class="spinner-border text-primary" role="status">
    <span class="sr-only">در حال بارگذاری...</span>
  </div>
</div>
